// mutations
export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL'
export const AJAX_CALL_ERROR = 'AJAX_CALL_ERROR'
export const AJAX_CALL_SUCCESS = 'AJAX_CALL_SUCCESS'

export const RECEIVE_LAST_POSTS = 'RECEIVE_LAST_POSTS'



// WEBPACK FOOTER //
// ./src/app/config/store/modules/posts/types.js